import styled from "styled-components";

export const Wrapper = styled.div`
  .filter{
    margin-bottom: 5px;
    display: flex;
    justify-content: right;
  }
  .pointer{
      cursor: pointer;
  }
  .scroll-button-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      .scroll-button {
          border: none;
          background: #131f28;
          padding: 15px;
          border-radius: 50%;
          
      }
  }
  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: 700px) {
      display: inline;
    }
  }
`;
